class MuseumMediaScroller extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.track = this.querySelector('.museum-media-gallery__track');
    this.cards = Array.from(this.track?.children || []);
    this.previous = this.querySelector('[data-media-previous]');
    this.next = this.querySelector('[data-media-next]');
    this.arrows = this.querySelector('.museum-media-gallery__arrows');
    this.dots = this.querySelector('.museum-media-gallery__dots');
    if (!this.track) return;
    this.cards.forEach((card, index) => this.createDot(card, index));
    this.previous?.addEventListener('click', this.previousCard);
    this.next?.addEventListener('click', this.nextCard);
    this.track.addEventListener('scroll', this.update, { passive: true });
    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.track);
    this.querySelectorAll('[data-media-open]').forEach((button) => button.addEventListener('click', this.openDialog));
    this.dialogs = Array.from(this.closest('.museum-media-gallery')?.querySelectorAll('dialog') || []);
    this.dialogs.forEach((dialog) => {
      dialog.querySelector('[data-media-close]')?.addEventListener('click', this.closeDialog);
      dialog.addEventListener('close', this.onDialogClose);
    });
    this.update();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.dialogs?.forEach((dialog) => {
      dialog.querySelector('[data-media-close]')?.removeEventListener('click', this.closeDialog);
      dialog.removeEventListener('close', this.onDialogClose);
    });
  }
  createDot(card, index) {
    if (!this.dots) return;
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'museum-media-gallery__dot'; button.setAttribute('aria-label', `Show media ${index + 1}`);
    button.addEventListener('click', () => card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }));
    this.dots.append(button);
  }
  step = () => this.cards[0]?.getBoundingClientRect().width + Number.parseFloat(getComputedStyle(this.track).gap || 0) || this.track.clientWidth;
  previousCard = () => this.track.scrollBy({ left: -this.step(), behavior: 'smooth' });
  nextCard = () => this.track.scrollBy({ left: this.step(), behavior: 'smooth' });
  update = () => {
    const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
    if (this.arrows) this.arrows.hidden = !overflow;
    if (this.dots) this.dots.hidden = !overflow;
    const closest = this.cards.reduce((best, card, index) => Math.abs(card.offsetLeft - this.track.scrollLeft) < Math.abs(this.cards[best].offsetLeft - this.track.scrollLeft) ? index : best, 0);
    this.dots?.querySelectorAll('button').forEach((dot, index) => dot.classList.toggle('is-active', index === closest));
    if (this.previous) this.previous.disabled = this.track.scrollLeft <= 1;
    if (this.next) this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 1;
  };
  openDialog = (event) => {
    const dialog = document.getElementById(event.currentTarget.dataset.mediaOpen);
    if (!dialog) return;
    this.lastTrigger = event.currentTarget;
    const content = dialog.querySelector('[data-media-content]');
    content.replaceChildren(dialog.querySelector('template').content.cloneNode(true));
    dialog.showModal();
  };
  closeDialog = (event) => event.currentTarget.closest('dialog')?.close();
  onDialogClose = (event) => {
    event.currentTarget.querySelector('[data-media-content]')?.replaceChildren();
    this.lastTrigger?.focus();
  };
}
customElements.get('museum-media-scroller') || customElements.define('museum-media-scroller', MuseumMediaScroller);
document.addEventListener('shopify:block:select', (event) => event.target.closest?.('.museum-media-gallery__card')?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }));
